import React from 'react';
import Link from 'next/link';
import data from '../data/pages/privacy-policy.yml';
import Terms from '../client/templates/common/terms/Terms';
import AppLayout from '../client/layouts/app-layout/AppLayout';
import PageHead from '../client/components/page-head/PageHead';

const {
  SEO,
} = data;

export default () => (
  <AppLayout>
    <PageHead SEO={SEO} />
    <Terms>
      <div>
        <section id="informativa-sul-trattamento-dei-dati-personali">
          <h1>
            INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI
          </h1>

          <p>
            DOVE.IT S.r.l., in qualità di titolare del trattamento, informa ai sensi dell&apos;art. 13 Regolamento UE n. 2016/679
            (in seguito &quot;<strong>GDPR</strong>&quot;) e del D.Lgs. 196/2003 (in seguito il &quot;<strong>Codice Privacy</strong>&quot; e, con il
            GDPR, la &quot;<strong>Normativa Privacy</strong>&quot;) che i dati forniti dagli utenti (gli &quot;<strong>Utenti</strong>&quot;)
            sul sito web <Link href="/">www.dove.it</Link> (in seguito il &quot;<strong>Sito</strong>&quot;), saranno trattati con le modalità e per le finalità seguenti:
          </p>
        </section>

        <section id="titolare-del-trattamento">
          <h2>
            1 – Titolare del trattamento
          </h2>

          <p>
            Titolare del trattamento è DOVE.IT (di seguito <em>&quot;<strong>DOVE.IT</strong>&quot; </em>o anche il <em>&quot;<strong>Titolare</strong>&quot;</em>),
            con sede legale in Via Nino Bixio, 7 - 20129, Milano – Tel: +39 02 87178289 – e-mail: <a href="mailto:privacy@dove.it">privacy@dove.it</a>
          </p>
        </section>

        <section id="oggetto-del-trattamento">
          <h2>
            2 – Oggetto del trattamento
          </h2>

          <p>
            Il trattamento avrà ad oggetto singole operazioni, o un complesso di operazioni, di trattamento (quali a mero
            titolo
            esemplificativo: raccolta, registrazione, organizzazione, conservazione, elaborazione, comunicazione,
            modificazione,
            selezione, utilizzo) dei seguenti dati personali forniti dall&apos;Utente in occasione della fruizione dei servizi
            resi
            da DOVE.IT tramite il Sito (i &quot;<em>Dati Personali</em>&quot; o anche i &quot;<em>Dati</em>&quot;):
          </p>

          <ul>
            <li>
              <strong>dati identificativi e di contatto</strong>, forniti dall&apos;utente in caso di registrazione al Sito ovvero
              nel caso di richieste informative trasmesse alla Società, comprendenti, tra l&apos;altro, nome, cognome, indirizzo
              e-mail, indirizzo e numero di telefono di rete fissa e/o cellulare;
            </li>

            <li>
              <strong>dati di navigazione</strong>: per il semplice accesso al Sito non è necessario il conferimento di alcun
              dato personale; tuttavia, i sistemi informatici e i <em>software</em> preposti al funzionamento del Sito
              acquisiscono, nel corso del normale esercizio, alcuni dati personali la cui trasmissione è implicita nell&apos;uso
              dei
              protocolli di comunicazione di Internet. Tali informazioni non sono raccolte per essere associate a soggetti
              identificati.
            </li>
          </ul>
        </section>

        <section id="finalita-del-trattamento">
          <h2>
            3 – Finalità del trattamento
          </h2>

          <p>
            I Dati Personali sono trattati:
          </p>

          <ol type="A">
            <li>
              senza il consenso espresso dell&apos;Utente (art. 6b GDPR), per le seguenti finalità:
            </li>
            <ol type="i">
              <li>
                processare una richiesta di contatto e/o di registrazione al Sito;
              </li>
              <li>
                gestire e mantenere il Sito;
              </li>
              <li>
                adempiere agli obblighi previsti dalla legge, da un regolamento, dalla normativa comunitaria o da un ordine
                dell&apos;Autorità;
              </li>
              <li>
                adempiere obblighi connessi alla gestione dei rapporti con gli Utenti;
              </li>
              <li>
                prevenire o scoprire attività fraudolente o abusi dannosi per i Siti;
              </li>
              <li>
                esercitare i diritti del Titolare, ad esempio il diritto di esercizio di un diritto in sede giudiziaria;
              </li>
            </ol>
            <li>
              con il consenso espresso dell&apos;Utente (art. 7 GDPR), per le seguenti finalità:
            </li>
            <ol type="i">
              <li>
                inviare tramite e-mail comunicazioni informative, inclusa la <em>newsletter</em>, riferite a prodotti e/o
                servizi
                di DOVE.IT, ivi compresi gli aggiornamenti relativi ad un immobile ovvero a criteri di ricerca già selezionati
                dagli Utenti;
              </li>
              <li>
                comunicare i dati medesimi a partner commerciali per finalità di marketing di questi ultimi,
                effettuate tramite strumenti automatizzati (es. email) e non automatizzati (posta cartacea,
                telefono con operatore), in qualità di autonomi titolari del trattamento.
              </li>
            </ol>
          </ol>
        </section>

        <section id="modalita-di-trattamento">
          <h2>
            4 – Modalità di trattamento
          </h2>

          <p>
            Il trattamento dei Dati personali è realizzato per mezzo delle operazioni indicate all&apos;art. 4 n. 2 GDPR e
            precisamente: raccolta, registrazione, organizzazione, conservazione, consultazione, elaborazione, modificazione,
            selezione, estrazione, raffronto, utilizzo, interconnessione, blocco, comunicazione, cancellazione e distruzione
            dei
            Dati.
          </p>

          <p>
            I Dati personali sono sottoposti a trattamento sia cartaceo che elettronico e/o automatizzato, mediante l&apos;uso dei
            siti web ospitati presso l&apos;infrastruttura Cloud di Google, zona eu-west-1b (Belgio) e gestiti dal Titolare.
          </p>

          <p>
            Il Titolare tratterà i Dati personali per il tempo necessario per adempiere alle finalità di cui sopra, e
            garantisce
            i seguenti tempi massimi di conservazione dei Dati:
          </p>

          <ul>
            <li>
              per le finalità sub art. 3A: successivamente alla fruizione del servizio per cui sono raccolti, i Dati
              potranno essere archiviati e mantenuti per un periodo massimo di 10 anni;
            </li>
            <li>per le finalità sub art. 3B: 2 anni dalla prestazione del consenso, con successivo aggiornamento dei
              Dati
              e rinnovo del consenso prestato.
            </li>
          </ul>
        </section>

        <section id="sicurezza">
          <h2>
            5 - Sicurezza
          </h2>

          <p>
            Il Titolare ha adottato una varietà di misure di sicurezza per proteggere i Dati contro il rischio di perdita,
            abuso
            o alterazione, coerentemente alle misure espresse nell&apos;art. 32 GDPR.
          </p>
        </section>

        <section id="accesso-e-comunicazione">
          <h2>
            6 – Accesso e Comunicazione
          </h2>

          <p>
            I Dati potranno essere resi accessibili per le finalità di cui al precedente art. 3:
          </p>

          <ul>
            <li>
              a dipendenti, collaboratori, associati e soci del Titolare, nella loro qualità di incaricati e/o responsabili
              interni del trattamento e/o amministratori di sistema;
            </li>
            <li>
              a società terze o altri soggetti (a titolo indicativo, <em>provider</em> del Sito, <em>cloud provider</em>,
              tecnici addetti all&apos;assistenza <em>hardware</em> e <em>software</em>, etc.) che svolgono attività in <em>outsourcing</em>
              per conto del Titolare, nella loro qualità di responsabili del trattamento.
            </li>
          </ul>

          <p>
            Senza l&apos;espresso consenso dell&apos;Utente (ex art. 6b GDPR), il Titolare potrà comunicare i Dati per le
            finalità
            di cui all&apos;art. 2A a Organismi di vigilanza, Autorità giudiziarie nonché a tutti gli altri soggetti ai quali la
            comunicazione sia obbligatoria per legge per l&apos;espletamento delle finalità dette.
          </p>
          <p>
            Senza l&apos;espresso consenso dell&apos;Utente, i Dati non potranno essere ceduti a terzi per il relativo utilizzo a fini
            propri, e dunque al di fuori dell&apos;accesso di cui al precedente art. 6.
          </p>
          <p>
            I Dati non saranno in ogni caso oggetto di diffusione.
          </p>
        </section>

        <section id="trasferimento-dei-dati">
          <h2>
            7 – Trasferimento dei Dati
          </h2>

          <p>
            La gestione e la conservazione dei Dati avverrà esclusivamente nel territorio dell&apos;Unione Europea, su<em> server</em>del
            Titolare ubicati in Belgio e/o di società terze incaricate e debitamente nominate quali responsabili del
            trattamento.
          </p>

          <p>
            Il Titolare garantisce che il trasferimento dei Dati in altri Paesi dell&apos;Unione Europea, diversi dall&apos;Italia e
            dal
            Belgio, è strettamente limitato all&apos;effettiva necessità di esserne a conoscenza. DOVE.IT adotterà le misure
            necessarie per proteggere i dati personali degli Utenti, e impedire l&apos;accesso non autorizzato. Tutte le
            informazioni
            degli Utenti saranno accessibili e trattate esclusivamente dai dipendenti di DOVE.IT coinvolti nelle finalità di
            cui
            al precedente art. 3, in qualsiasi Paese, nonché da terzi autorizzati quali società che forniscono valutazioni
            per
            assistere il Titolare nell&apos;ambito delle predette finalità.
          </p>
        </section>

        <section id="natura-del-conferimento-dei-dati-e-conseguenze-del-rifiuto-di-rispondere">
          <h2>
            8 - Natura del conferimento dei dati e conseguenze del rifiuto di rispondere
          </h2>

          <p>
            Il conferimento dei Dati per le finalità di cui all&apos;art. 3A è obbligatorio. In loro assenza, non potranno
            essere
            garantite all&apos;Utente né la risposta a richieste di contatto, né l&apos;accesso ai servizi di DOVE.IT.
          </p>

          <p>
            Il conferimento dei Dati per le finalità di cui all&apos;art. 3B è invece facoltativo. L&apos;Utente può decidere di non
            conferire alcun Dato o di negare successivamente la possibilità di trattare i Dati forniti senza nessuna conseguenza
            sulla prestazione all&apos;Utente dei servizi, funzionalità e informazioni richiesti tramite il Sito.
          </p>
        </section>

        <section id="diritti-dellinteressato">
          <h2>
            9 - Diritti dell&apos;interessato
          </h2>

          <p>
            Nella qualità di interessati, agli Utenti sono riconosciuti tutti i diritti di cui alla Normativa Privacy, e
            precisamente i diritti di:
          </p>

          <ul>
            <li>
              ottenere la conferma dell&apos;esistenza o meno di Dati Personali che riguardano l&apos;Utente, anche se non ancora
              registrati, e la loro comunicazione in forma intelligibile;
            </li>
            <li>
              ottenere l&apos;indicazione: a) dell&apos;origine dei Dati Personali; b) delle finalità e modalità del trattamento; c)
              della logica applicata in caso di trattamento effettuato con l&apos;ausilio di strumenti elettronici; d) degli
              estremi
              identificativi del Titolare, dei responsabili e del rappresentante designato ai sensi dell&apos;art. 5, comma 2
              Codice
              Privacy e art. 3, comma 1, GDPR; e) dei soggetti o delle categorie di soggetti ai quali i Dati Personali
              possono
              essere comunicati o che possono venirne a conoscenza in qualità di rappresentante designato nel territorio
              dello
              Stato, di responsabili o incaricati;
            </li>
            <li>
              ottenere: a) l&apos;aggiornamento, la rettificazione ovvero, quando l&apos;Utente vi abbia interesse, l&apos;integrazione dei
              Dati; b) la cancellazione, la trasformazione in forma anonima o il blocco dei Dati trattati in violazione di
              legge,
              compresi quelli di cui non è necessaria la conservazione in relazione agli scopi per i quali i Dati sono stati
              raccolti o successivamente trattati; c) l&apos;attestazione che le operazioni di cui alle lettere a e b sono state
              portate a conoscenza, anche per quanto riguarda il loro contenuto, di coloro ai quali i Dati sono stati
              comunicati
              o diffusi, eccettuato il caso in cui tale adempimento si rivela impossibile o comporta un impiego di mezzi
              manifestamente sproporzionato rispetto al diritto tutelato;
            </li>
            <li>
              opporsi, in tutto o in parte: a) per motivi legittimi al trattamento dei Dati Personali che riguardano
              l&apos;Utente,
              ancorché pertinenti allo scopo della raccolta; b) al trattamento di Dati Personali che riguardano l&apos;Utente a
              fini
              di invio di materiale pubblicitario o di vendita diretta o per il compimento di ricerche di mercato o di
              comunicazione commerciale, mediante l&apos;uso di sistemi automatizzati di chiamata senza l&apos;intervento di un
              operatore
              mediante e-mail e/o mediante modalità di marketing tradizionali mediante telefono e/o posta cartacea. Si fa
              presente che il diritto di opposizione dell&apos;interessato, esposto al precedente punto b), per finalità di
              marketing
              diretto mediante modalità automatizzate si estende a quelle tradizionali e che comunque resta salva la
              possibilità
              per l&apos;interessato di esercitare il diritto di opposizione anche solo in parte. Pertanto, l&apos;interessato può
              decidere
              di ricevere solo comunicazioni mediante modalità tradizionali ovvero solo comunicazioni automatizzate oppure
              nessuna delle due tipologie di comunicazione.
            </li>
          </ul>

          <p>
            Ove applicabili, agli Utenti sono riconosciuti altresì i diritti di cui agli artt. 16-21 GDPR (Diritto di
            rettifica,
            diritto all&apos;oblio, diritto di limitazione di trattamento, diritto alla portabilità dei Dati, diritto di
            opposizione),
            nonché il diritto di reclamo all&apos;Autorità Garante.
          </p>
        </section>

        <section id="modalita-di-esercizio-dei-diritti">
          <h2>
            10 - Modalità di esercizio dei diritti
          </h2>

          <p>
            L&apos;Utente potrà in qualsiasi momento esercitare i diritti inviando:
          </p>

          <ul>
            <li>
              una e-mail all&apos;indirizzo <a href="mailto:privacy@dove.it">privacy@dove.it</a>;
            </li>
            <li>
              una raccomandata a.r. a DOVE.IT S.r.l., Via Nino Bixio, 7 - 20129 Milano.
            </li>
          </ul>
        </section>

        <section id="cookie">
          <h2>
            11 – Cookie
          </h2>

          <p>
            Informazioni inerenti la gestione dei cookie nel Sito sono riportate nella sezione <Link href="/cookie-policy">COOKIE POLICY</Link> presente sul Sito, e alla quale per completezza si rinvia.
          </p>
        </section>

        <section id="responsabile-e-incaricati">
          <h2>
            12 – Responsabile e incaricati
          </h2>

          <p>
            L&apos;elenco aggiornato dei responsabili e degli incaricati al trattamento è custodito presso la sede del Titolare.
          </p>
        </section>

        <section id="modifiche-alla-presente-informativa">
          <h2>
            13 - Modifiche alla presente informativa
          </h2>

          <p>
            La presente informativa può subire variazioni. Si consiglia, quindi, di controllare regolarmente questa informativa e di riferirsi alla versione più aggiornata.
          </p>
        </section>

        <section id="proprieta-intellettuale-e-tutela-del-marchio">
          <h2>
            PROPRIETÀ INTELLETTUALE E TUTELA DEL MARCHIO
          </h2>

          <p>
            Le pagine di questo Sito sono protette da <em>copyright</em>, contrassegnate dal simbolo © ai sensi della legge
            633/1941; dunque, il contenuto del Sito è protetto contro duplicazioni, traduzioni. Inoltre la tutela del
            marchio,
            è
            protetto ai sensi dell&apos;articolo 2571 c.c.
          </p>
        </section>
      </div>
    </Terms>
  </AppLayout>
);
